/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { versionIsVersionSupported } from '../fn/version/version-is-version-supported';
import { VersionIsVersionSupported$Params } from '../fn/version/version-is-version-supported';

@Injectable({ providedIn: 'root' })
export class VersionApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `versionIsVersionSupported()` */
  static readonly VersionIsVersionSupportedPath = '/api/version/version-supported';

  /**
   * Check if Version is supported.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `versionIsVersionSupported()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionIsVersionSupported$Response(params?: VersionIsVersionSupported$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = versionIsVersionSupported(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Check if Version is supported.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `versionIsVersionSupported$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  versionIsVersionSupported(params?: VersionIsVersionSupported$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.versionIsVersionSupported$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
